import Benefits from "./landingpage/benefits/benefits";
import Registration from "./landingpage/registration/registration";
import Welcome from "./landingpage/welcome/welcome";
import React from "react";

const Landingpage = (): React.JSX.Element => (
  <React.Fragment>
    <Welcome />
    <Benefits />
    <Registration />
  </React.Fragment>
);

export default Landingpage;
